import { render, staticRenderFns } from "./NewSiteNavbar.vue?vue&type=template&id=78764896&scoped=true&lang=pug&"
import script from "./NewSiteNavbar.vue?vue&type=script&lang=ts&"
export * from "./NewSiteNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./NewSiteNavbar.vue?vue&type=style&index=0&id=78764896&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78764896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
